var _a;
import { Log, LogCategory } from '@augloop/logging';
export var ConfigPatchOperationType;
(function (ConfigPatchOperationType) {
    ConfigPatchOperationType["Add"] = "Add";
    ConfigPatchOperationType["Remove"] = "Remove";
    ConfigPatchOperationType["Set"] = "Set";
    ConfigPatchOperationType["Delete"] = "Delete";
})(ConfigPatchOperationType || (ConfigPatchOperationType = {}));
export class ConfigPatchOperationHelper {
    static applyECSPatchOperation(operation, settingValue) {
        let success = false;
        // apply the operation. operations will only apply to complex objects and arrays
        if (typeof settingValue === 'object' || Array.isArray(settingValue)) {
            switch (operation.operation) {
                case ConfigPatchOperationType.Add:
                case ConfigPatchOperationType.Remove:
                    success = ConfigPatchOperationHelper.applyAddOrRemoveOperation(operation.path, settingValue, operation.value, operation.operation);
                    break;
                case ConfigPatchOperationType.Set:
                    success = ConfigPatchOperationHelper.applySetOperation(operation.path, settingValue, operation.value);
                    break;
                case ConfigPatchOperationType.Delete:
                    success = ConfigPatchOperationHelper.applyDeleteOperation(operation.path, settingValue, operation.value);
                    break;
            }
        }
        if (!success) {
            Log.error(0x1e28471a /* tag_4ke20 */, LogCategory.CoreDefault, `PATCH operation failed for ${operation.operation} on ${operation.settingName} with path: ${operation.path}`);
        }
        else {
            Log.verbose(0x1e284719 /* tag_4ke2z */, LogCategory.CoreDefault, `PATCH operation succeeded for ${operation.operation} on ${operation.settingName} with path: ${operation.path}.`);
        }
        return success;
    }
    // This helper method combines the logic for both Add and Remove operations on arrays, as the implementation is similar for both
    static applyAddOrRemoveOperation(path, configValue, patchOperationValue, configOperationType) {
        let success = false;
        try {
            let arrayForModification = [];
            if (typeof configValue === 'object' && !Array.isArray(configValue)) {
                arrayForModification = path.reduce((accumulator, property) => {
                    return accumulator && accumulator[property];
                }, configValue);
            }
            else if (Array.isArray(configValue)) {
                arrayForModification = configValue;
            }
            if (Array.isArray(arrayForModification)) {
                if (configOperationType === ConfigPatchOperationType.Add) {
                    arrayForModification.push(patchOperationValue);
                    success = true;
                }
                else if (configOperationType === ConfigPatchOperationType.Remove) {
                    const ix = arrayForModification.indexOf(patchOperationValue);
                    if (ix >= 0) {
                        arrayForModification.splice(ix, 1);
                        success = true;
                    }
                }
            }
        }
        catch (error) {
            Log.info(0x1e2878c0 /* tag_4kh9a */, LogCategory.CoreDefault, `Exception thrown while applying operation type: ${configOperationType} for an array. Error: ${error}`);
            success = false;
        }
        return success;
    }
    // Applies set operation for dictionary within the config value
    static applySetOperation(path, configValue, patchOperationValue) {
        let success = false;
        try {
            const propertiesBeforeParent = path.slice(0, -1);
            const lastProperty = path[path.length - 1];
            let dictForModification = {};
            if (typeof configValue === 'object' && !Array.isArray(configValue)) {
                dictForModification = propertiesBeforeParent.reduce((accumulator, property) => {
                    return accumulator && accumulator[property];
                }, configValue);
                if (typeof dictForModification === 'object' && !Array.isArray(dictForModification)) {
                    dictForModification[lastProperty] = patchOperationValue;
                    success = true;
                }
            }
        }
        catch (error) {
            Log.info(0x1e2878a2 /* tag_4kh88 */, LogCategory.CoreDefault, `Exception thrown while applying set operation. Error: ${error}`);
            success = false;
        }
        return success;
    }
    // Applies delete operation for dictionary within the config value
    static applyDeleteOperation(path, configValue, keyToBeRemoved) {
        let success = false;
        try {
            let dictForModification = {};
            if (typeof configValue === 'object' && !Array.isArray(configValue)) {
                dictForModification = path.reduce((accumulator, property) => {
                    return accumulator && accumulator[property];
                }, configValue);
                if (typeof dictForModification === 'object' && !Array.isArray(dictForModification) && typeof keyToBeRemoved === 'string') {
                    if (dictForModification.hasOwnProperty(keyToBeRemoved)) {
                        delete dictForModification[keyToBeRemoved];
                        success = true;
                    }
                }
            }
        }
        catch (error) {
            Log.info(0x1e2878a1 /* tag_4kh87 */, LogCategory.CoreDefault, `Exception thrown while applying delete operation. Error: ${error}`);
            success = false;
        }
        return success;
    }
}
_a = ConfigPatchOperationHelper;
ConfigPatchOperationHelper.parseECSOperation = (settingName, patchValue) => {
    if (!patchValue.hasOwnProperty('operationType') || !patchValue.hasOwnProperty('path') || !patchValue.hasOwnProperty('value')) {
        // patch operation has an invalid format
        throw new Error(`Invalid format for PATCH operation on setting: ${settingName}`);
    }
    const parsedOperationType = patchValue.operationType.toLowerCase();
    const operation = _a.convertToConfigPatchOperationType(parsedOperationType);
    const path = patchValue.path ? patchValue.path.split('.') : [];
    const result = { settingName, path: path, operation, value: patchValue.value };
    return result;
};
ConfigPatchOperationHelper.convertToConfigPatchOperationType = (operation) => {
    switch (operation) {
        case 'add':
            return ConfigPatchOperationType.Add;
        case 'remove':
            return ConfigPatchOperationType.Remove;
        case 'set':
            return ConfigPatchOperationType.Set;
        case 'delete':
            return ConfigPatchOperationType.Delete;
        default:
            throw new Error(`Invalid operation type: ${operation}`);
    }
};
//# sourceMappingURL=patch-operation.js.map